import { validator } from "@/utils/validator";

export const loginCredentialsSchema = validator.object().shape({
  email: validator.string().trim().emptyToNull().autoTransformToHalfWidth().label("メールアドレス").required(),
  password: validator.string().trim().emptyToNull().autoTransformToHalfWidth().label("パスワード").required(),
});
